import { useDispatch } from "react-redux";
import { signout } from "../../../redux/slices/auth-slice";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const onClickHandler = () => {
    dispatch(signout());
    navigate("/");
  };
  return (
    <div
      className="flex text-xs font-medium py-1 pl-8"
      onClick={onClickHandler}
    >
      <img className="w-3 h-4 pt-1 mr-3 " src="/images/Exit.png" alt="" />
      Logout
    </div>
  );
};
export default Logout;
